<template>
  <div>
    <!-- 分类 -->
    <template v-if="showCategory">
      <CategoriesSelect
        :showCategory="showCategory"
        :showBanner="showBanner"
        :bannerList="bannerList"
        :allCategory="allCategory"
        @go-search="linkToSearch"
      />
    </template>
    <!-- 频道专区 -->
    <ResoureBanner v-if="showChannel" :channels="channels" />
    <!-- 活动专区 -->
    <template v-if="showActiveGoods">
      <ActiveGoods v-for="active in activeList" :key="active.name" :max="activeGoodsMax" :active="active" @update-cart="updateCart" />
    </template>
    <!-- 品质店铺 -->
    <!-- <StoreRecommend v-if="showStore" :storeList="storeList" :storeLink="storeLink" /> -->
    <!-- 分类专区 -->
    <template v-if="showCategoryGoods">
      <CategoryGoods v-for="(category, index) in categoryList" :key="index" :category="category" />
    </template>
    <!-- 推荐商品 -->
    <GoodsRecommend
      v-if="showRecommendGoods"
      :goodsList="recommendGoodsList"
      @load-more="loadMoreGoods"
      :hasMore="hasMore"
      @update-cart="updateCart"
    />
    <QuickNav
      v-if="resourceList.length"
      :active="showActiveGoods"
      :goodsDrug="showCategoryGoods"
      :goodsRecommend="showRecommendGoods"
    />
  </div>
</template>
<script>
import * as api from '@/services';
import CategoriesSelect from './components/Categories/CategoriesSelect';
import ResoureBanner from './components/ResoureBanner';
import ActiveGoods from './components/ActiveGoods';
import StoreRecommend from './components/StoreRecommend';
import CategoryGoods from './components/CategoryGoods';
import GoodsRecommend from './components/GoodsRecommend';
import QuickNav from './components/QuickNav';

export default {
  components: {
    CategoriesSelect,
    ResoureBanner,
    ActiveGoods,
    StoreRecommend,
    CategoryGoods,
    GoodsRecommend,
    QuickNav
  },
  data() {
    return {
      resourceList: [],
      showCategory: false,
      allCategory: [],
      showBanner: false,
      bannerList: [],
      showChannel: false,
      channels: [],
      showActiveGoods: false,
      activeGoodsMax: 0,
      activeList: [],
      showStore: false,
      storeList: [],
      storeLink: '',
      showCategoryGoods: false,
      categoryList: [],
      searchRecommendGoodsParams: {
        pageNo: 1,
        pageSize: 30,
        aggregateFlag: false,
        saleOutStatus: 0, // 售罄状态 0/1/2 未售罄/售罄/全部
      },
      showRecommendGoods: false,
      recommendGoodsList: [],
      hasMore: true
    };
  },
  watch: {
    '$parent.resourceList'() {
      this.init();
    }
  },
  mounted() {
    Telescope.trackPage({
      trackId: 'zyb2bpc-page-sy-scsyB2B'
    })
  },
  methods: {
    // 处理获取的资源列表
    init() {
      this.resourceList = this.$parent.resourceList;
      let length = this.resourceList.length;
      for (let i = 0; i < length; i++) {
        this.matching(this.resourceList[i]);
      }
    },
    updateCart() {
      // 加购成功获取购物车数量
      this.$emit('update-cart');
    },
    matching(resource) {
      switch (resource.resourceCode) {
        case 'BRS_BANNER':
          this.handleGroup(resource);
          break;
        case 'BRS_CHANNEL':
          this.handleChannel(resource);
          break;
        case 'BRS_ACTIVITY_GOODS':
          this.handleActivitygoods(resource);
          break;
        case 'BRS_STORE':
          this.handleStore(resource);
          break;
        case 'BRS_CATEGORY_GOODS':
          this.handleCategorygoods(resource);
          break;
        case 'BRS_GOODS_RECOMMEND':
          this.handleGoodsrecommend(resource);
          break;
        default:
          break;
      }
    },
    handleGroup({ banners }) {
      this.bannerList = banners;
      this.getAllCategory();

      this.showBanner = true;
      this.showCategory = true;

      // resources.forEach(resource => {
      //   if (resource.resourceCode == 'BRS_CATEGORY') {
      //     this.showCategory = true;
      //     this.getAllCategory();
      //   }
      //   if (resource.resourceCode == 'BRS_BANNER') {
      //     this.showBanner = true;
      //     this.bannerList = banners;
      //   }
      // });
    },
    handleChannel({ channels }) {
      this.channels = channels;
      this.showChannel = true;
    },
    handleActivitygoods(resource) {
      this.showActiveGoods = true;
      this.activeList = resource.zones;
      this.activeGoodsMax = resource.goodsNumMax;
    },
    handleStore(resource) {
      this.showStore = true;
      this.storeList = resource.stores;
      this.storeLink = resource.more;
    },
    handleCategorygoods(resource) {
      this.showCategoryGoods = true;
      this.categoryList = resource.zones;
    },
    handleGoodsrecommend(resource) {
      this.showRecommendGoods = true;
      this.getRecommendGoods();
    },
    // 获取所有类目信息
    async getAllCategory() {
      const allCategory = await api.goods.getGoodsCategory();
      this.allCategory = allCategory;
    },
    linkToSearch({ title, content, code }) {
      this.$router.push({
        path: `/mallHomePage/goodsList`,
        query: {
          title,
          content,
          code
        }
      });
    },
    // 获取推荐商品列表
    async getRecommendGoods() {
      const {
        data: { itemBasicInfos },
        totalRecord
      } = await api.goods.getGoodsList(this.searchRecommendGoodsParams);
      this.recommendGoodsList = this.recommendGoodsList.concat(itemBasicInfos);
      this.hasMore = this.recommendGoodsList.length < totalRecord;
    },
    // 获取更多推荐商品
    loadMoreGoods() {
      this.searchRecommendGoodsParams.pageNo += 1;
      this.getRecommendGoods();
    }
  },
  created() {
    this.init();
  }
};
</script>

<style></style>
